import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AUTH_TOKEN } from 'constants/AuthConstant';
import { signOut } from 'store/slices/authSlice';

const isJwtExpired = (token) => {
	if (!token || typeof token !== 'string') {
		return false;
	}

	const parts = token.split('.');
	if (parts.length !== 3) {
		return false;
	}

	try {
		const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')));
		return typeof payload.exp === 'number' && payload.exp * 1000 <= Date.now();
	} catch (error) {
		return false;
	}
};

const AuthSessionGuard = () => {
	const dispatch = useDispatch();
	const token = useSelector((state) => state.auth?.token);

	useEffect(() => {
		if (!token) {
			localStorage.removeItem(AUTH_TOKEN);
			return;
		}

		if (isJwtExpired(token)) {
			dispatch(signOut());
			return;
		}

		if (localStorage.getItem(AUTH_TOKEN) !== token) {
			localStorage.setItem(AUTH_TOKEN, token);
		}
	}, [token, dispatch]);

	return null;
};

export default AuthSessionGuard;
